/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var OnboardingBrokerStatus;

(function (OnboardingBrokerStatus) {
  OnboardingBrokerStatus["PENDING_ONBOARDING"] = "pending_onboarding";
  OnboardingBrokerStatus["ACTIVE"] = "active";
  OnboardingBrokerStatus["ON_HOLD"] = "on_hold";
  OnboardingBrokerStatus["INACTIVE"] = "inactive";
  OnboardingBrokerStatus["TERMINATED"] = "terminated";
})(OnboardingBrokerStatus || (OnboardingBrokerStatus = {}));